import type { UpdateTreeReplacementInput } from '../../../../api/tree-replacements/types';
import type { TreeReplacementDetail } from '../../../../api/workshops';

import {
  displayedNote,
  EMPTY_TREE_REPLACEMENT_FORM,
  type TreeReplacementFormValues,
} from './tree-replacement-form';

/** The edit form opens on the replacement as stored, with whichever note the row shows. */
export function editValuesFrom(detail: TreeReplacementDetail): TreeReplacementFormValues {
  return {
    ...EMPTY_TREE_REPLACEMENT_FORM,
    firstName: detail.firstName ?? '',
    lastName: detail.lastName ?? '',
    email: detail.email ?? '',
    phone: detail.phone ?? '',
    treeCount: String(detail.treeCount ?? 1),
    treeSpeciesId: detail.treeSpecies?.id ?? '',
    staffNotes: displayedNote(detail) ?? '',
  };
}

const CLEARABLE = ['lastName', 'email', 'phone', 'staffNotes'] as const;

/** Only the fields the person changed, so an untouched FareHarbor note is never copied
 *  into the staff note. A field emptied by the person is sent as null to clear it. */
export function toEditPatch(
  initial: TreeReplacementFormValues,
  values: TreeReplacementFormValues,
): UpdateTreeReplacementInput {
  const changed = (key: keyof TreeReplacementFormValues) =>
    values[key].trim() !== initial[key].trim();
  const patch: UpdateTreeReplacementInput = {};
  if (changed('firstName')) patch.firstName = values.firstName.trim();
  for (const key of CLEARABLE) {
    if (changed(key)) patch[key] = values[key].trim() || null;
  }
  if (changed('treeCount')) patch.treeCount = Number(values.treeCount);
  if (changed('treeSpeciesId')) patch.treeSpeciesId = values.treeSpeciesId || null;
  return patch;
}
